export enum ETalentRoutes {
  TALENT_DASHBOARD = 'Talent.Dashboard',
  TALENT_MESSAGES = 'Talent.Messages',
  TALENT_VIBE_TALENT = 'Talent.VibeTalent',
  TALENT_CONNECTIONS = 'Talent.Connections',
  TALENT_DETAIL = 'Talent.Detail'
}
